import { gql } from "@/services/httpAdapter";

export const onUpdateSystemSettingsPositionMapping = gql`
	subscription onUpdateSystemSettingsPositions($locationId: String!) {
		onUpdateSystemSettingsPositions(locationId: $locationId) {
			locationId
			mappedPositions {
				_id
				isDepartmental
				payrollPosition
				systemPosition
				overtime
			}
			requiredPositions {
				_id
				isDepartmental
				payrollPosition
				systemPosition
			}
			accountingPositions
		}
	}
`;

export const onCreateUsers = gql`
	subscription onCreateUsers($locationId: String!) {
		onCreateUsers(locationId: $locationId) {
			locationId
		}
	}
`;
